import {Disposable, Environment, commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {
	MissionControlActivateSageIntacctInput,
	MissionControlActivateSageIntacctMutation,
} from './__generated__/MissionControlActivateSageIntacctMutation.graphql';
import RelayEnvironment from '../../../RelayEnvironment';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../ts/MutationTypes';

const mutation = graphql`
	mutation MissionControlActivateSageIntacctMutation($input: MissionControlActivateSageIntacctInput!) {
		MissionControlActivateSageIntacct(input: $input) {
			outcome
			errorMessage
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<MissionControlActivateSageIntacctInput>,
	onSuccess: RelayOnCompleted<MissionControlActivateSageIntacctMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(RelayEnvironment.getInstanceMC(), {
		mutation,
		variables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
